import React, {useState, useEffect, createContext} from 'react'
import gameStages from './gameData/gameStagesData'

const PlayerStatsContext = createContext()

function PlayerStatsProvider({children}) {
    const [authorised, setAuthorised] = useState(false)
    const [gameSaved, setGameSaved] = useState(false)
    const [databaseStage, setDatabaseStage] = useState(0)
    const [playerStats, setPlayerStats] = useState({
        office: 'locked',
        laboratory: 'locked',
        library: 'locked',
        fourJokers: 'locked',
        lastStand: 'locked',
        machine: 'locked',
        gameState: 'newGame'
    })
    
    // Possible locationStates = locked, open, complete
    // Possible gameStates = newGame continueGame machineGame winGame
    
    function updatePlayerStats(action) {
        setPlayerStats(prevStats => {
            return {
                ...prevStats,
                [action.name]: action.newState
            }
        })
    }

    useEffect(() => {
        setPlayerStats(gameStages[databaseStage])
    }, [databaseStage])
        
    useEffect(() => {
        const {gameState, machine, office, lastStand} = playerStats
        if (gameState !== 'winGame' && machine === 'complete') {
            updatePlayerStats({name: 'gameState', newState: 'winGame'})
        }  else if (gameState === 'newGame' && office === 'complete') {
            updatePlayerStats({name: 'gameState', newState: 'continueGame'})
        } else if (gameState === 'continueGame' && lastStand === 'complete') {
            updatePlayerStats({name: 'gameState', newState: 'machineGame'})
        }
    }, [playerStats])
    
    useEffect(() => {
        const {library, laboratory, fourJokers, lastStand} = playerStats
        if (library === 'complete' && laboratory === 'complete' && fourJokers === 'complete' && lastStand === 'locked') {
            updatePlayerStats({name: 'lastStand', newState: 'open'})
        }
    }, [playerStats])
    
    const context = {
        authorised,
        setAuthorised,
        playerStats,
        updatePlayerStats,
        setPlayerStats,
        setDatabaseStage,
        gameSaved,
        setGameSaved,
    }
    
    return (
        <PlayerStatsContext.Provider value={context}>
            {children}
        </PlayerStatsContext.Provider>
    )
}

export {PlayerStatsProvider, PlayerStatsContext}